import React, { useEffect } from "react";
import Button from "@/core/components/button/Button";
import { useUnit } from "effector-react";
import { facebookLoginRequested, $authStore } from "../store/auth";
import { imageList } from "@/core/utils/imageList";

// Extend Window interface for Facebook SDK
declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}

interface FacebookLoginButtonProps {
  isLoginPage?: boolean;
}

const FacebookLoginButton = ({ isLoginPage }: FacebookLoginButtonProps) => {
  const { loading, error } = useUnit($authStore);
  const facebookLogin = useUnit(facebookLoginRequested);

  useEffect(() => {
    // Load Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "1376978975742977",
        cookie: true,
        xfbml: true,
        version: "v25.0",
      });
    };

    // Load SDK script
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode?.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const handleFacebookLogin = () => {
    window.FB.login(
      (response: any) => {
        //console.log("Facebook login response:", response);
        if (response.authResponse) {
          facebookLogin({
            access_token: response.authResponse.accessToken,
            expires_in: response.authResponse.expiresIn,
          });
        } else {
          //console.log("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "public_profile,email" },
    );
  };

  return (
    <div className="social-login">
      <Button
        className="social-btn facebook-btn"
        variant="secondary"
        size="normal"
        outlined
        onClick={handleFacebookLogin}
        loading={loading}
        disabled={loading}
      >
        <span className="social-icon">
          <img src={imageList.fbIcon} alt="fb-icon" />
        </span>
        {isLoginPage && <span>Sign in with Facebook</span>}
      </Button>

      {/* {error && <div className="error-toast">{error}</div>} */}
    </div>
  );
};

export default FacebookLoginButton;
